import React, { useState } from 'react'
import { Input, Button } from 'reactstrap'
import styles from '../../styles/common/getFreeTrial.module.css'
import Image from 'next/image';

const GetFreeTrial = ({ setDemoModal }) => {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [error, setErrors] = useState({
        phoneNumber: ""
    })

    const handleGetStarted = () => {
        if (phoneNumber.trim() === "") {
            setErrors({ phoneNumber: "Please enter your mobile phone number." });
        } else if (!/^\d{10,15}$/.test(phoneNumber.replace(/\s+/g, ''))) {
            setErrors({ phoneNumber: "Please enter a valid phone number (10-15 digits)." });
        } else {
            setErrors({ phoneNumber: "" });
            if (setDemoModal) {
                setDemoModal(true);
            }
        }
    };
    return (
        <>
            <div  >
                <div style={{ position:'relative', overflow:'hidden',display: 'flex', justifyContent:"space-between", alignItems: 'center',   backgroundColor:"#FEF4E8",padding: "4rem ", borderRadius:"2rem", margin:"0 18rem", fontFamily:"GilroyMedium", }}>
                    
                    
                      <div style={{ width: '50%',  }}>
                        <h3 style={{fontSize:"2.6rem",fontWeight:700, fontFamily:"GilroySemiBold"}}>Get Started with  <span style={{color:"#F68E1E"}}>14 Day Free Trial</span></h3>
                    <p style={{fontSize:"1.3rem"}}>Connect with our enterprise sales experts and get comprehensive <br />POS Solutions tailored for your large business.</p>
                      </div>
                    
                    <div className={styles.contact_InputSection} >
                        <Input 
                            type='tel'
                            style={{ border: "none", fontSize: "1.4rem", color: '#919497', outline: "none",     borderRadius: "0.5rem" }}
                            placeholder="Enter your Mobile Phone Number"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                        <Button onClick={handleGetStarted} >
                            Get Started
                        </Button>
                    </div>
                    {error.phoneNumber && (
                        <p className={styles.error_message}>
                            {error.phoneNumber}
                        </p>
                    )}



                    <div style={{position:'absolute', width:'45rem', height:"50rem", left:"0rem", top:'0rem'}}><Image src="/assets/petStore/Ellipse_left.svg" fill alt='Pet Store Ellipse' /></div>
                    <div style={{position:'absolute', width:'50rem', height:"22rem", right:"0rem", top:"0rem"}}> <Image src="/assets/petStore/Ellipse_right.svg" fill alt='Pet Store Ellipse' /></div>

                </div>
            </div>
        </>
    )
}

export default GetFreeTrial